import { getApiOrigin } from '../config/api';

const LOOPBACK_HOSTNAMES = new Set(['127.0.0.1', 'localhost']);

export function normalizeMediaUrl(mediaUrl?: string | null): string | undefined {
  if (!mediaUrl) {
    return undefined;
  }

  if (mediaUrl.startsWith('data:')) {
    return mediaUrl;
  }

  const apiOrigin = getApiOrigin();

  if (mediaUrl.startsWith('/uploads/')) {
    return apiOrigin ? new URL(mediaUrl, `${apiOrigin}/`).toString() : mediaUrl;
  }

  try {
    const parsedUrl = new URL(mediaUrl);

    if (parsedUrl.pathname.startsWith('/uploads/')) {
      if (LOOPBACK_HOSTNAMES.has(parsedUrl.hostname) && apiOrigin) {
        return new URL(`${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`, `${apiOrigin}/`).toString();
      }

      return parsedUrl.toString();
    }
  } catch {
    if (mediaUrl.startsWith('uploads/')) {
      return apiOrigin ? new URL(mediaUrl, `${apiOrigin}/`).toString() : `/${mediaUrl}`;
    }

    return mediaUrl;
  }

  return mediaUrl;
}
